<template>
  <div
    class="group grid h-[320px] w-[266px] cursor-pointer grid-flow-row content-center justify-center gap-6 rounded-md bg-gray-600 text-gray-200 hover:text-gray-100"
  >
    <div v-if="$slots.icon" class="transition duration-300">
      <slot name="icon" />
    </div>
    <h1
      class="max-w-[140px] whitespace-pre-line text-center font-inter text-sm font-semibold leading-5 text-gray-100 transition duration-300 group-hover:text-gray-50"
    >
      {{ headerTitle }}
    </h1>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    headerTitle: string;
  }>();
</script>
